import React from 'react';

type PanelPublicationProps = {
  merits: string[];
};

const PanelMerit: React.FunctionComponent<PanelPublicationProps> = (
  props: PanelPublicationProps,
) => {
  const { merits } = props;

  return (
    <>
      {merits.length === 0 ? (
        <div className="text-center">{'-'}</div>
      ) : (
        <div className="w-full text-left">
          {merits.map((merit, index) => (
            <div key={index} className="text-[#951D1D]">
              {index + 1}&nbsp;
              <i>{merit}</i>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
const MemoizedPanelMerit = React.memo(PanelMerit);
export { MemoizedPanelMerit };
